// extracted by mini-css-extract-plugin
export default {"container":"header_container__RyDCz","title":"header_title__uh+DJ","text":"header_text__fN8pf"};